import React, { createContext, useState, useContext, useCallback } from "react";

// Context oluştur
const PurchaseContext = createContext();

// Context Provider
export const PurchaseProvider = ({ children }) => {
  const [purchaseData, setPurchaseData] = useState({
    carpetTypes: [],
    productDetails: {}, // Her ürün için detaylar
    contact: {
      phone: "",
      name: ""
    },
    address: {
      provinceId: "",
      districtId: "",
      neighbourhoodId: "",
      line1: ""
    },
    createAccount: false,
    estimatedDeliveryDate: "",
    dealerId: null
  });

  // Halı tiplerini güncelle
  const updateCarpetTypes = useCallback((carpetTypes) => {
    setPurchaseData(prev => ({
      ...prev,
      carpetTypes
    }));
  }, []);

  // İletişim bilgilerini güncelle
  const updateContact = useCallback((contact) => {
    setPurchaseData(prev => ({
      ...prev,
      contact: {
        ...prev.contact,
        ...contact
      }
    }));
  }, []);

  // Adres bilgilerini güncelle
  const updateAddress = useCallback((address) => {
    setPurchaseData(prev => ({
      ...prev,
      address: {
        ...prev.address,
        ...address
      }
    }));
  }, []);

  // Üyelik oluşturma seçeneğini güncelle
  const updateCreateAccount = useCallback((createAccount) => {
    setPurchaseData(prev => ({
      ...prev,
      createAccount
    }));
  }, []);

  // Tahmini teslimat tarihini güncelle
  const updateEstimatedDeliveryDate = useCallback((date) => {
    setPurchaseData(prev => ({
      ...prev,
      estimatedDeliveryDate: date
    }));
  }, []);

  // Bayi ID'sini güncelle
  const updateDealerId = useCallback((dealerId) => {
    setPurchaseData(prev => ({
      ...prev,
      dealerId
    }));
  }, []);

  // Ürün detaylarını güncelle
  const updateProductDetails = useCallback((productDetails) => {
    setPurchaseData(prev => ({
      ...prev,
      productDetails
    }));
  }, []);

  // Tüm veriyi sıfırla
  const resetPurchaseData = useCallback(() => {
    setPurchaseData({
      carpetTypes: [],
      productDetails: {},
      contact: {
        phone: "",
        name: ""
      },
      address: {
        provinceId: "",
        districtId: "",
        neighbourhoodId: "",
        line1: ""
      },
      createAccount: false,
      estimatedDeliveryDate: "",
      dealerId: null
    });
  }, []);

  const value = {
    purchaseData,
    updateCarpetTypes,
    updateContact,
    updateAddress,
    updateCreateAccount,
    updateEstimatedDeliveryDate,
    updateDealerId,
    updateProductDetails,
    resetPurchaseData
  };

  return (
    <PurchaseContext.Provider value={value}>
      {children}
    </PurchaseContext.Provider>
  );
};

// Custom hook
export const usePurchase = () => {
  const context = useContext(PurchaseContext);
  if (!context) {
    throw new Error("usePurchase must be used within a PurchaseProvider");
  }
  return context;
};